export default __webpack_public_path__ + "static/media/pulse.1b46eecf.png";